import { Inject, Injectable } from '@angular/core';
import { NAVIGATOR } from '@ng-web-apis/common';
import { catchError, map, Observable, throwError } from 'rxjs';

@Injectable()
export class SearchResultsFallbackService {
  constructor(@Inject(NAVIGATOR) private navigator: Navigator) {}

  getFallbackLocation() {
    return this.getLocation().pipe(
      catchError((err: GeolocationPositionError) =>
        throwError(() => new Error(`status: ${err?.code}, message: ${err?.message}`)),
      ),
      map(res => ({ latitude: res?.coords?.latitude, longitude: res?.coords?.longitude })),
    );
  }

  private getLocation(): Observable<GeolocationPosition> {
    return new Observable(obs => {
      this.navigator.geolocation.getCurrentPosition(
        success => {
          obs.next(success);
          obs.complete();
        },
        error => {
          obs.error(error);
        },
      );
    });
  }
}
